document.addEventListener('DOMContentLoaded', () => {
    const buttons = document.querySelectorAll('.accordion-item-title');
    const panels = document.querySelectorAll('.accordion-item-body');

    // 🔹 INITIALISATION AU CHARGEMENT
    buttons.forEach(button => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));

        if (button.classList.contains('active') && panel) {
            button.setAttribute('aria-expanded', 'true');
            panel.classList.add('open');
            panel.style.maxHeight = panel.scrollHeight + 'px';
        } else {
            button.setAttribute('aria-expanded', 'false');
            if (panel) {
                panel.classList.remove('open');
                panel.style.maxHeight = null;
            }
        }
    });

    // 🔹 GESTION DES CLICS
    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const isActive = button.classList.contains('active');

            // Fermer tous les accordéons
            buttons.forEach(btn => {
                btn.classList.remove('active');
                btn.setAttribute('aria-expanded', 'false');
            });

            panels.forEach(panel => {
                panel.classList.remove('open');
                panel.style.maxHeight = null;
            });

            // Ouvrir celui cliqué
            if (!isActive) {
                button.classList.add('active');
                button.setAttribute('aria-expanded', 'true');

                const panel = document.getElementById(button.getAttribute('aria-controls'));

                if (panel) {
                    panel.classList.add('open');
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            }
        });
    });
});
